import { render, staticRenderFns } from "./crearExamen.vue?vue&type=template&id=754d2de1&scoped=true&"
import script from "./crearExamen.vue?vue&type=script&lang=js&"
export * from "./crearExamen.vue?vue&type=script&lang=js&"
import style0 from "./crearExamen.vue?vue&type=style&index=0&id=754d2de1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754d2de1",
  null
  
)

export default component.exports